import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './CwShellLeftNavButton.scss';
import CwImage from '../../cwimage/CwImage';
import {CwShellLeftNavExpand} from '../constants';
import CwShellLeftNavLink from '../cwshellleftnavlink/CwShellLeftNavLink';
import CwLabel from '../../cwlabel/CwLabel';

const CwShellLeftNavButton = (props) => {

  const handleMouseEnter = () => {
    // fire onMouseEnter callback if it exists
    if (typeof props.onMouseEnter === 'function') {
      props.onMouseEnter();
    }
    // set this as the active button if the menu is in DEFAULT mode
    if (props.expand === CwShellLeftNavExpand.DEFAULT &&
        typeof props.setActiveButton === 'function') {
      props.setActiveButton(props.id);
    }
  };

  const handleMouseLeave = () => {
    // fire onMouseLeave callback if it exists
    if (typeof props.onMouseLeave === 'function') {
      props.onMouseLeave();
    }
    // set null as the active button if the menu is in DEFAULT mode
    if (props.expand === CwShellLeftNavExpand.DEFAULT &&
        typeof props.setActiveButton === 'function') {
      props.setActiveButton(null);
    }
  };

  const handleClick = () => {
    // fire onClick callback if it exists
    if (typeof props.onClick === 'function') {
      props.onClick();
    }
    // set this as the active button if the menu is in FAT mode
    if (props.expand === CwShellLeftNavExpand.FAT &&
        typeof props.setActiveButton === 'function') {
      props.setActiveButton(props.id);
    }
  };

  const renderChildren = () => {
    return React.Children.map(props.children, child => {
      return React.cloneElement(child, {
        active: props.activeLink === child.props.id,
        collapseIcon: props.collapseIcon,
        expandIcon: props.expandIcon,
        setActiveLink: props.setActiveLink
      });
    });
  };

  const buttonClass = cx(
    css.cwShellLeftNavButton,
    {
      [css.collapsed]: props.expand === CwShellLeftNavExpand.COLLAPSED,
      [css.default]: props.expand === CwShellLeftNavExpand.DEFAULT,
      [css.fat]: props.expand === CwShellLeftNavExpand.FAT,
      [css.active]: props.active
    }
  );

  const linkContainerClass = cx(
    css.cwShellLeftNavLinkContainer,
    {
      [css.default]: props.expand === CwShellLeftNavExpand.DEFAULT
    }
  );

  return (
  <div
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    style={props.style}
  >
    <div
      className={buttonClass}
      onClick={handleClick}
    >
      <CwImage
        className={css.cwShellLeftNavButtonIcon}
        src={props.icon}
      />
      <CwLabel className={css.cwShellLeftNavButtonLabel}>
        {props.label}
      </CwLabel>
    </div>
    {props.active && props.children &&
    <div className={linkContainerClass}>
      {renderChildren()}
    </div>
    }
  </div>
  );
};

CwShellLeftNavButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.oneOf([CwShellLeftNavLink])
    }),
    PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf([CwShellLeftNavLink])
    }))
  ]),
  /**
   * Unique identifier
   */
  id: PropTypes.number,
  /**
   * Determines if the 'active' class is applied to button and if children are shown
   */
  active: PropTypes.bool,
  /**
   * Current active link
   */
  activeLink: PropTypes.number,
  /**
   * Path to collapse icon to pass to CwShellLeftNavLink children
   */
  collapseIcon: PropTypes.string,
  /**
   * Path to expand icon to pass to CwShellLeftNavLink children
   */
  expandIcon: PropTypes.string,
  /**
   * State of the parent CwShellLeftNav component
   */
  expand: PropTypes.oneOf([
     CwShellLeftNavExpand.COLLAPSED,
     CwShellLeftNavExpand.DEFAULT,
     CwShellLeftNavExpand.FAT
  ]),
  /**
   * Path to main icon
   */
  icon: PropTypes.string.isRequired,
  /**
   * Text Displayed
   */
  label: PropTypes.string.isRequired,
  /**
   * Callback function that is fired on mouse click
   */
  onClick: PropTypes.func,
  /**
   * Callback function that is fired on mouse enter
   */
  onMouseEnter: PropTypes.func,
  /**
   * Callback function that is fired on mouse leave
   */
  onMouseLeave: PropTypes.func,
  /**
   * Callback function to set the active button
   */
  setActiveButton: PropTypes.func,
  /**
   * Callback function to set the active link
   */
  setActiveLink: PropTypes.func,
  /**
   * Allows custom styling
   */
  style: PropTypes.object,
};

export default CwShellLeftNavButton;


// WEBPACK FOOTER //
// ./src/components/cwshellleftnav/cwshellleftnavbutton/CwShellLeftNavButton.jsx